import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from '../../../components/navigation';
import Bundle from '../store/Bundle';
import classes from './BundleTable.module.scss';

export default function BundleTable({ bundles }: { bundles: Bundle[] }) {
  const navigate = useNavigate();

  function showBundle(bundleId: string) {
    navigate(`/bundles/${bundleId}`);
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Price</TableCell>
            <TableCell align="right">&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bundles.map((bundle) => (
            <TableRow
              className={classes.row}
              key={bundle.id}
              onClick={() => showBundle(bundle.id)}
            >
              <TableCell component="th" scope="row">
                {bundle.displayName}
              </TableCell>
              <TableCell align="right">{bundle.displayPrice}</TableCell>
              <TableCell align="right">
                <LinkButton
                  icon="pen"
                  size="small"
                  to={`/bundles/${bundle.id}`}
                  type="primaryText"
                >
                  Edit
                </LinkButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
